export default __webpack_public_path__ + "static/media/zertiassist_iconos_user_24px.f16c9fa7.svg";